import {HeadCell} from "interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "code",
    disablePadding: true,
    label: "Código",
  },
  {
    id: "client",
    disablePadding: false,
    label: "Cliente",
  },
  {
    id: "dni",
    disablePadding: false,
    label: "Cédula",
  },
  {
    id: "email",
    disablePadding: false,
    label: "Correo",
  },
  {
    id: "phone",
    disablePadding: false,
    label: "Teléfono",
  },
  {
    id: "status",
    disablePadding: false,
    label: "Estatus",
  },
  {
    id: "action",
    disablePadding: false,
    label: "",
  },
];
